document.addEventListener("DOMContentLoaded", function() {
    var titleElements = document.querySelectorAll('.collection--title');

    titleElements.forEach(function(titleElement) {
        var nextElement = titleElement.nextElementSibling;

        // 次の要素が存在し、かつ次の要素が子要素を持たない場合に非表示にする
        if (nextElement && nextElement.children.length === 0) {
            titleElement.classList.add('hidden');
        }
    });
});